import { Institution } from "../../models/institutions";
import {
  AdminInstitution,
  GetAdminsQuery,
  NewInstitutionAdmins,
  PlanAdmins,
  RemoveAdmin,
} from "../../models/institutions-admins";
import { UserByEmail } from "../../models/user";
import { api } from "./api";

export const institutionsAdminApi = api.injectEndpoints({
  endpoints: (build) => ({
    newInstitutionAdmins: build.mutation<void, NewInstitutionAdmins>({
      query: (data) => ({
        url: "institutions-admins",
        method: "POST",
        body: data,
      }),
    }),
    getAdminUserByEmail: build.mutation<UserByEmail, string>({
      query: (email) => ({
        url: `institutions-admins/by-email/${email}`,
      }),
    }),
    getAdminUserByDocument: build.mutation<UserByEmail, string>({
      query: (document) => ({
        url: `institutions-admins/by-document/${document}`,
      }),
    }),
    getInstitutionAdmins: build.query<PlanAdmins, GetAdminsQuery>({
      query: ({ id, page, pageSize, documentNumber, firstName, lastName }) => ({
        url: `institutions-admins/${id}`,
        method: "GET",
        params: { page, pageSize, documentNumber, firstName, lastName },
      }),
    }),
    removeAdmin: build.mutation<void, RemoveAdmin>({
      query: ({ institutionId, userId }) => ({
        url: `institutions-admins/${institutionId}/${userId}`,
        method: "DELETE",
      }),
    }),
    changeOwner: build.mutation<void, RemoveAdmin>({
      query: ({ institutionId, userId }) => ({
        url: `institutions-admins/owner/${institutionId}/${userId}`,
        method: "PATCH",
      }),
    }),
    getAdminInstitutions: build.query<Institution[], string>({
      query: (userId) => ({
        url: `institutions-admins/${userId}/institutions`,
        method: "GET",
      }),
    }),
    getAdminInstitution: build.query<Institution, AdminInstitution>({
      query: ({ userId, institutionId }) => ({
        url: `institutions-admins/${userId}/institutions/${institutionId}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useNewInstitutionAdminsMutation,
  useGetInstitutionAdminsQuery,
  useRemoveAdminMutation,
  useGetAdminInstitutionsQuery,
  useGetAdminInstitutionQuery,
  useChangeOwnerMutation,
  useGetAdminUserByEmailMutation,
  useGetAdminUserByDocumentMutation,
} = institutionsAdminApi;
